import GenericCrudService from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/services/GenericCrudService";
import HttpClient from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/utils/HttpClient";
import ApiResponse from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/core/ApiResponse";
import Timeoff from "../models/Timeoff";
import PagedResult from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/core/PagedResult";
import { Documentation } from "../models/Documentation";
import TimeOffReport from "../models/TimeOffReport";
import { RemainingVacancies } from "../utils/enums/RemainingVacancies";
import VacationReport from "../models/VacationReport";
import HttpClientV2 from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/utils/HttpClientV2";
import ApiResponseV2 from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/core/ApiResponseV2";
import { TimeoffRequestersAndHours } from "../models/TimeoffRequestersAndHours";

class TimeoffService extends GenericCrudService<Timeoff> {
  path: string;

  constructor(path: string) {
    super(path);
    this.path = path;
  }

  getFormData(timeOff: Timeoff, documents: Documentation[]): FormData {
    const formData = new FormData();

    timeOff.documentation = documents.filter((d) => d.url !== undefined);
    formData.append("dto", JSON.stringify(timeOff));

    return formData;
  }

  createTimeOff(timeOff: Timeoff, documents: Documentation[], coreUserExternalId: string): Promise<ApiResponse<string>> {
    return HttpClient.post(`${this.path}/create/${coreUserExternalId}`, this.getFormData(timeOff, documents));
  }

  updateTimeOff(timeOff: Timeoff, documents: Documentation[]): Promise<ApiResponse<string>> {
    return HttpClient.put(`${this.path}/update/${timeOff.externalId}`, this.getFormData(timeOff, documents));
  }

  getTimeOff(
    page: number,
    pageSize: number,
    searchFilter: string,
    statusFilter: string,
    dateFilter: string,
    projectFilter: string,
    year?: number,
    month?: number
  ): Promise<ApiResponse<PagedResult<Timeoff>>> {
    return HttpClient.get(
      `${this.path}/filtered?page=${page}&pageSize=${pageSize}` +
        `&searchFilter=${searchFilter}&statusFilter=${statusFilter}&dateFilter=${dateFilter}` +
        `&projectFilter=${projectFilter}&year=${year || ""}&month=${month || ""}`
    );
  }

  changeStatus(timeoff: Timeoff, status: string): Promise<ApiResponse<Timeoff>> {
    return HttpClient.put(`${this.path}/status/${status}`, timeoff, true);
  }

  getTimeOffReport(
    year: number,
    month: number,
    page: number,
    pageSize: number,
    searchFilter: string,
    remainingVacancies: string
  ): Promise<ApiResponse<PagedResult<TimeOffReport>>> {
    return HttpClient.get(
      `${this.basePath}/report?year=${year}&month=${month}&page=${page}&pageSize=${pageSize}&remainingVacancies=${
        Object.keys(RemainingVacancies)[Object.values(RemainingVacancies).indexOf(remainingVacancies as unknown as RemainingVacancies)]
      }&searchFilter=${searchFilter}`,
      true
    );
  }

  getVacationReport(
    year: number,
    month: number,
    page: number,
    pageSize: number,
    searchFilter: string,
    remainingVacancies: string,
    externalId: string
  ): Promise<ApiResponse<PagedResult<VacationReport>>> {
    return HttpClient.get(
      `${this.basePath}/vacation-report?year=${year}&month=${month}&page=${page}&pageSize=${pageSize}&remainingVacancies=${
        Object.keys(RemainingVacancies)[Object.values(RemainingVacancies).indexOf(remainingVacancies as unknown as RemainingVacancies)]
      }&searchFilter=${searchFilter}&externalId=${externalId}`,
      true
    );
  }

  getRequesterTimeOff(externalId: string): Promise<ApiResponseV2<Timeoff[]>> {
    return HttpClientV2.get(`${this.basePath}/get-requester-timeoff?externalId=${externalId}`);
  }

  getVacationBalance(userExternalId: string, year: number, month: number): Promise<ApiResponseV2<VacationReport>> {
    let query = `${this.basePath}/vacation-balance/${userExternalId}?year=${year}&month=${month}`;
    return HttpClientV2.get(query);
  }

  getTimeOffExternalSummary(): Promise<ApiResponse<TimeoffRequestersAndHours[]>> {
    let query = `${this.basePath}/get-timeoff-extra-view`;
    return HttpClient.get(query, true);
  }
}

export default new TimeoffService("/ensolvers-ops/timeoff");
